import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconRain: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="none">
        <path
          d="M44.5197 61.5071L34.8359 88.4375H39.6161L49.2886 61.5071H44.5197Z"
          fill="#87D6F8"
        />
        <path
          d="M54.2931 61.5071L44.6094 88.4375H49.3895L59.0733 61.5071H54.2931Z"
          fill="#87D6F8"
        />
        <path
          d="M64.0665 61.5071L54.3828 88.4375H59.163L68.8467 61.5071H64.0665Z"
          fill="#87D6F8"
        />
        <path
          d="M34.8924 61.5071L30 74.9723H34.7689L39.6725 61.5071H34.8924Z"
          fill="#87D6F8"
        />
        <path
          d="M79.5531 37.7185C78.33 37.2136 76.9723 36.9331 75.5584 36.9331H70.4304V31.951C70.4304 23.6923 65.2576 16.6006 57.8966 13.5709C55.4392 12.5611 52.7461 12 49.9072 12C40.3581 12 32.4025 18.3735 30.1134 26.9576H29.384C20.8897 26.9576 14 33.6565 14 41.9152C14 48.1092 17.8825 53.428 23.4032 55.7058C25.2434 56.4576 27.2745 56.884 29.3952 56.884H34.5232H65.3024H75.5584C81.2251 56.884 85.8144 52.4181 85.8144 46.9086C85.8144 42.7792 83.2336 39.2334 79.5531 37.7185Z"
          fill="#87D6F8"
        />
      </svg>
    </svg>
  )
}

export default WeatherIconRain
